exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-picker-panel__shortcut {\n    font-size: 13px;\n}\n", ""]);

// exports
